const normalizeToDefaultTeamAPI = (data, meta) => {
  const teamName = data.generalSettings.defaultTeam;
  const selectedTeam = meta.allTeams.filter(team => team.name === teamName)[0];
  return { team_id: selectedTeam ? selectedTeam.id : undefined };
};

export default normalizeToDefaultTeamAPI;
